// src/pages/FAQ.jsx
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

const FAQ_KEYS = [
  'size', 'delay', 'shipping', 'payment', 'exchange', 'open',
  'international', 'care', 'custom', 'tracking', 'gift', 'contact'
];

function FAQ() {
  const { t } = useTranslation();
  const [openIndex, setOpenIndex] = useState(null);

  return (
    <main className="faq-page">
      <header className="page-hero">
        <div className="page-hero__inner">
          <span className="page-hero__label">{t('faq.heroLabel')}</span>
          <h1 className="page-hero__title">{t('faq.heroTitle')}</h1>
          <p className="page-hero__subtitle">{t('faq.heroSubtitle')}</p>
        </div>
      </header>

      <section className="faq-content">
        <div className="faq-list">
          {FAQ_KEYS.map((key, i) => (
            <div key={key} className={`faq-item ${openIndex === i ? 'is-open' : ''}`}>
              <button className="faq-question" onClick={() => setOpenIndex(openIndex === i ? null : i)}>
                <span>{t(`faq.items.${key}.q`)}</span>
                <span className="faq-icon">{openIndex === i ? '−' : '+'}</span>
              </button>
              {openIndex === i && (
                <div className="faq-answer">{t(`faq.items.${key}.a`)}</div>
              )}
            </div>
          ))}
        </div>

        <div className="faq-cta">
          <h3>{t('faq.ctaTitle')}</h3>
          <p>{t('faq.ctaText')}</p>
          <a href="https://wa.me/212669428878" target="_blank" rel="noreferrer" className="btn btn-primary">
            {t('faq.ctaButton')}
          </a>
        </div>
      </section>
    </main>
  );
}

export default FAQ;